import s from './TMT.module.scss';

const GameHeader: React.FC<{ children: string }> = ({ children }) => (
  <h1 className={s.gameHeader}>
    {children}
  </h1>
);

export default GameHeader;
